import React from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';

import { reduxFormPropTypes } from 'constants/propTypes';
import Message from 'components/Message';
import { SvgImageUpload, SvgEdit } from 'components/Svgs/';
import { messages } from './InstructorFormOptionalLabel';

const InstructorFormAvatar = ({ name, input, pictureUrl }) => {
  const files = input.value;
  const picture = files ? URL.createObjectURL(files[0]) : pictureUrl;
  const pictureAlt = files ? files[0].name : 'Avatar';
  const handleOnDrop = filesToUpload => input.onChange(filesToUpload);

  return (
    <div className="instructor-form__avatar">
      <Dropzone accept={{ 'image/jpeg': [], 'image/png': [], 'image/gif': [] }} name={name} onDrop={handleOnDrop}>
        {({ getRootProps, getInputProps }) => (
          <div className="instructor-form__dropzone" {...getRootProps()}>
            <input {...getInputProps()} />
            {picture ? (
              <div className="instructor-form__filled-picture">
                <img className="instructor-form__picture" src={picture} alt={pictureAlt} />
                <SvgEdit className="instructor-form__add-icon" stroke="red" />
              </div>
            ) : (
              <div className="instructor-form__empty-picture">
                <SvgImageUpload />
                <Message
                  as="p"
                  className="instructor-form__empty-picture-optional-text"
                  message={messages.optionalLabel}
                />
              </div>
            )}
          </div>
        )}
      </Dropzone>
    </div>
  );
};

InstructorFormAvatar.propTypes = {
  pictureUrl: PropTypes.string,
  name: PropTypes.string,
  input: reduxFormPropTypes.field.input,
};

export default InstructorFormAvatar;
